export class ProductOptions extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['option', 'selected-variant']
  }

  setupListeners () {
    super.setupListeners()

    /** Auto select the selected item */
    const optionTarget = this.querySelector('[data-option-value-id]')
    if (optionTarget?.dataset.optionName) {
      const optionLabel = this.querySelector(
        `[data-product-options-el="label"][data-option-name="${optionTarget.dataset.optionName}"]`,
      )
      if (optionLabel?.dataset.default) {
        optionLabel.textContent = optionLabel.dataset.default
      }
    }
    /** end */

    this.updateOptionStateAttributes()

    this.listeners.add(this, 'change', this.onProductOptionChange.bind(this))

    for (const option of this.els.option.elements) {
      this.listeners.add(
        option,
        'mouseenter',
        this.onProductOptionEnter.bind(this),
      )
      this.listeners.add(
        option,
        'mouseleave',
        this.onProductOptionLeave.bind(this),
      )
    }
  }

  onProductOptionChange (event) {
    if (
      event.target instanceof HTMLInputElement &&
      event.target.type === 'radio'
    ) {
      this.updateOptionStateAttributes()
    }

    const target =
      event.target.tagName === 'SELECT'
        ? event.target.selectedOptions[0]
        : event.target

    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_SELECTED, {
      event,
      target,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  onProductOptionEnter (event) {
    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_ENTERED, {
      event,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  onProductOptionLeave (event) {
    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_EXITED, {
      event,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  updateOptionStateAttributes () {
    const optionInputs = this.querySelectorAll(
      'fieldset [data-variant-radios-el="option-choice"]',
    )

    for (const optionInput of optionInputs) {
      if (!(optionInput instanceof HTMLInputElement)) continue
      if (optionInput.type !== 'radio') continue

      const optionLabel = optionInput.nextElementSibling
      if (!(optionLabel instanceof HTMLLabelElement)) continue

      optionLabel.setAttribute(
        'aria-current',
        optionInput.checked ? 'true' : 'false',
      )
    }
  }

  get selectedOptionValues () {
    return Array.from(
      this.querySelectorAll('select option[selected], fieldset input:checked'),
    ).map(({ dataset }) => dataset.optionValueId)
  }

  get selectedVariant () {
    return JSON.parse(this.els['selected-variant'].element.innerHTML)
  }
}

if (!customElements.get('product-options')) {
  customElements.define('product-options', ProductOptions)
}
